import React, { FC, useState, useEffect } from "react";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";

export interface IImage {
  src: string;
  width: number;
  height: number;
  className?: string;
  style?: any;
  onLoad?: any;
  alt?: string;
  delay?: boolean;
  position?: string;
  afterLoad?: () => void;
}

const QUALITY = 70;

const Image: FC<IImage> = ({
  src,
  width,
  height,
  className,
  onLoad,
  style,
  position = "center",
  afterLoad,
}) => {
  const [loaded, setLoaded] = useState(false);

  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      setLoaded(true);
      if (onLoad) {
        onLoad();
      }
    }
  }, [inView]);

  const smallWidth = Math.floor(width / 10);
  const smallHeight = Math.floor(height / 10);

  const small = `${process.env.NEXT_PUBLIC_OPTIM_ENDPOINT}/${smallWidth}/${smallHeight}/${QUALITY}/?url=${src}&fit=cover&position=${position}&blur=2`;

  const getSrc1x = (quality = QUALITY) =>
    loaded
      ? `${process.env.NEXT_PUBLIC_OPTIM_ENDPOINT}/${width}/${height}/${quality}/?url=${src}&fit=cover&position=${position}`
      : small;
  const getSrc2x = (quality = QUALITY) =>
    loaded
      ? `${process.env.NEXT_PUBLIC_OPTIM_ENDPOINT}/${width * 2}/${
          height * 2
        }/${quality}/?url=${src}&fit=cover&position=${position}`
      : small;

  const srcSetWebp = `${getSrc1x()}&format=webp, ${getSrc2x()}&format=webp 2x`;
  const srcSet = `${getSrc2x(90)} 2x`;

  return (
    <picture>
      <source srcSet={srcSetWebp} type="image/webp" />
      <ImageElement
        ref={ref}
        src={getSrc1x(90)}
        srcSet={srcSet}
        width={width}
        height={height}
        className={className}
        onLoad={() => {
          if (afterLoad) {
            afterLoad();
          }
        }}
        alt=""
        style={style}
      />
    </picture>
  );
};

const ImageElement = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

export default Image;
